import _createForOfIteratorHelper from "@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from "react";
import { Accordion as BootstrapAccordion, AccordionCollapse as Collapse, Row, Col } from "react-bootstrap";
import { FormCheckbox } from "../forms/elements";
import { Field, withFormik, FieldArray, Form } from "formik"; //ga tracker

import gaTracker from '../../util/ga-analytics/gaTracker';
var formikEnhancer = withFormik({
  enableReinitialize: true,
  displayName: "SearchCategorySelect" // helps with React DevTools

});

var SidebarCategory = function SidebarCategory(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var name = props.name,
      _props$categories = props.categories,
      categories = _props$categories === void 0 ? [] : _props$categories,
      index = props.index;
  var isColor = name === "Color";
  return categories.length && name ? /*#__PURE__*/React.createElement(BootstrapAccordion, {
    onSelect: function onSelect() {
      return setOpen(!open);
    }
  }, /*#__PURE__*/React.createElement(BootstrapAccordion.Toggle, {
    className: "\n          cb-accordion__toggle\n          ".concat(open ? 'is-active' : '', "\n          cb-type-subheading-1\n          "),
    as: "a",
    eventKey: "search-".concat(index)
  }, name), /*#__PURE__*/React.createElement(BootstrapAccordion.Collapse, {
    eventKey: "search-".concat(index),
    in: !open,
    isopen: open.toString()
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-accordion__body"
  }, isColor ? /*#__PURE__*/React.createElement(ColorOptions, props) : categories.map(function (option, index) {
    return /*#__PURE__*/React.createElement(SidebarOption, _extends({}, props, {
      key: "option" + index,
      name: option.Name,
      count: option.Count,
      catName: name,
      index: index,
      value: option.Value
    }));
  })))) : null;
};

var handleOption = function handleOption(checked, name, category, categoriesChange, topicChange, priceChange, modifierChange, categorySlug) {
  // console.log(categorySlug, "slug")
  var filterClick = function filterClick(catName, name) {
    var data = {
      gtm: {
        uniqueEventId: '7',
        elementTarget: catName + '|' + name,
        elementId: catName + '|' + name
      },
      event: 'gtm.click'
    };
    gaTracker(data);
  };

  switch (category) {
    case 'Categories':
      categoriesChange(name, checked);
      filterClick(category, name);
      break;

    case 'Topics':
      topicChange(name, checked);
      filterClick(category, name);
      break;

    case 'Price':
      priceChange(name, checked);
      filterClick(category, name);
      break;

    default:
      modifierChange(name, checked, category, categorySlug);
      filterClick(category, name);
      break;
  }
};

var SidebarOption = function SidebarOption(props) {
  var name = props.name,
      count = props.count,
      catName = props.catName,
      index = props.index,
      _props$categoriesChan = props.categoriesChange,
      categoriesChange = _props$categoriesChan === void 0 ? function () {
    return console.log("categoriesChange");
  } : _props$categoriesChan,
      _props$topicChange = props.topicChange,
      topicChange = _props$topicChange === void 0 ? function () {
    return console.log("topicChange");
  } : _props$topicChange,
      _props$priceChange = props.priceChange,
      priceChange = _props$priceChange === void 0 ? function () {
    return console.log("priceChange");
  } : _props$priceChange,
      _props$modifierChange = props.modifierChange,
      modifierChange = _props$modifierChange === void 0 ? function () {
    return console.log("modifierChange");
  } : _props$modifierChange,
      value = props.value,
      facetName = props.facetName;
  return /*#__PURE__*/React.createElement(React.Fragment, null, name && count !== 0 && /*#__PURE__*/React.createElement(Field, {
    type: "checkbox",
    name: "".concat(catName, ".").concat(index),
    label: "".concat(name),
    checked: value,
    component: FormCheckbox,
    id: catName + '|' + name,
    onClick: function onClick(e) {
      e.persist();
      handleOption(e.target.checked, name, catName, categoriesChange, topicChange, priceChange, modifierChange, facetName);
    }
  }));
};

var Sidebar = function Sidebar(props) {
  var facets = props.facets; // console.log(facets, "FACETS")

  var checkFacetsCount = function checkFacetsCount(facetsValue) {
    var name = '';

    if (facetsValue === null || facetsValue === void 0 ? void 0 : facetsValue.Values) {
      var _iterator = _createForOfIteratorHelper(facetsValue.Values),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var facet = _step.value;

          if (facet.Count !== 0) {
            name = facetsValue.Name;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return name;
    }
  };

  return /*#__PURE__*/React.createElement(FieldArray, {
    name: "Topic",
    render: function render(arrayHelpers) {
      return /*#__PURE__*/React.createElement("div", {
        className: "cb-search-sidebar"
      }, facets && facets.length > 0 ? facets.map(function (topic, index) {
        return /*#__PURE__*/React.createElement(SidebarCategory, _extends({}, props, {
          key: "sidebardCat" + topic.Name + index,
          name: topic.DisplayName || checkFacetsCount(topic),
          categories: topic.FoundValues || topic.Values,
          index: index,
          facetName: topic.Name
        }));
      }) : "");
    }
  });
};

var ColorOptions = function ColorOptions(props) {
  var categories = props.categories,
      index = props.index,
      catName = props.catName,
      categoriesChange = props.categoriesChange,
      topicChange = props.topicChange,
      priceChange = props.priceChange,
      modifierChange = props.modifierChange,
      facetName = props.facetName; // name={option.Name}
  // count={option.Count}
  // catName={name}
  // index={index}
  // value={option.Value}

  return /*#__PURE__*/React.createElement(Row, {
    className: "cb-search-sidebar--clear"
  }, categories.map(function (option, index) {
    var nameExists = Boolean(option.Name);
    var countExists = Boolean(option.Count);
    return nameExists && countExists && /*#__PURE__*/React.createElement(Col, {
      key: "color" + index
    }, /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        return handleOption(!option.Value, option.Name, name, categoriesChange, topicChange, priceChange, modifierChange, facetName);
      },
      className: "cb-search-sidebar__color-option  ".concat(option.Name.toLowerCase(), " ").concat(option.Value ? "is-active" : "")
    }));
  }) // <SidebarOption
  //   {...props}
  //   name={option.Name}
  //   count={option.Count}
  //   catName={name}
  //   index={index}
  //   value={option.Value}/>)
  );
};

export default formikEnhancer(Sidebar);